import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../assets/img/icons/search_2.svg";

export const HeaderSearch = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedQuery = query.trim();
    navigate(
      `/search${trimmedQuery ? `?query=${encodeURIComponent(trimmedQuery)}` : ""}`,
    );
    setShowSearch(false);
    setQuery("");
  };

  return (
    <>
      <button
        className="td_center td_search_tobble_btn"
        type="button"
        onClick={() => setShowSearch((v) => !v)}
        style={{
          backgroundColor: "transparent",
          border: "none",
        }}
      >
        <img src={SearchIcon} alt="Search" />
      </button>

      <div className={`td_header_search_wrap ${showSearch && "active"}`}>
        <form className="td_header_search" onSubmit={handleSubmit}>
          <input
            type="text"
            className="td_header_search_input"
            placeholder="Search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
          <button type="submit" className="td_header_search_btn td_center">
            <img src={SearchIcon} alt="Search" />
          </button>
        </form>
      </div>
    </>
  );
};
